'use client';
import { HeartIcon as HeartOutlineIcon } from '@heroicons/react/24/outline';
import { HeartIcon } from '@heroicons/react/24/solid';
import { cva } from 'class-variance-authority';
import { useState } from 'react';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';

export const buttonVariants = cva('size-5', {
  variants: {
    liked: {
      true: 'text-(--color-surface-primary-dark)',
      false: '',
    },
  },
  defaultVariants: { liked: true },
});

interface Props {
  trackId?: string;
}

export function PlayerLikeButton(
  {
    // trackId,
  }: Props,
) {
  const [liked, setLiked] = useState<boolean>(false);

  return (
    <div>
      <Button variant="ghost" onClick={() => setLiked(prev => !prev)}>
        <HeroIcon
          className={buttonVariants({ liked })}
          icon={liked ? HeartIcon : HeartOutlineIcon}
        />
      </Button>
    </div>
  );
}
